import { useState, useEffect } from 'react'
import type { JSX } from 'react'

import styles from './Onboarding.module.css'
import { OnboardingBody } from './OnboardingBody'
import { WelcomeAnimation } from './welcome-animation/WelcomeAnimation'

function Onboarding(): JSX.Element {
  const [showWelcomeAnimation, setShowWelcomeAnimation] = useState(true)
  const [beginTransition, setBeginTransition] = useState(false)

  useEffect(() => {
    setTimeout(() => setBeginTransition(true), 3700)
    setTimeout(() => setShowWelcomeAnimation(false), 4000)
  }, [])

  return (
    <div className={styles.wrapper} data-testid="ai-assistant-onboarding-panel">
      {showWelcomeAnimation ? (
        <WelcomeAnimation beginTransition={beginTransition} />
      ) : (
        <OnboardingBody />
      )}
    </div>
  )
}

export { Onboarding }
